import React, { useState, useEffect } from "react";
import { X, CheckSquare, MessageSquare } from "lucide-react";

export default function ResolveTicketModal({ isOpen, onClose, ticketNumber, onResolve, submitting }) {
  const [note, setNote] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (isOpen) {
      setNote("");
      setError("");
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!note.trim()) {
      setError("Please enter a resolution note before completing the ticket.");
      return;
    }
    setError("");
    onResolve(note.trim());
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: "450px" }}>
        <div className="modal-header">
          <h3 style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <CheckSquare size={20} className="text-success" /> Complete Ticket {ticketNumber}
          </h3>
          <button className="modal-close" onClick={onClose} disabled={submitting}>
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} style={{ padding: "1.5rem" }}>
          {error && (
            <div className="alert alert-danger" style={{ marginBottom: "1rem" }}>
              {error}
            </div>
          )}

          <div className="form-group">
            <label className="form-label" htmlFor="resolutionNote" style={{ display: "flex", alignItems: "center", gap: "0.3rem" }}>
              <MessageSquare size={14} /> Resolution Details *
            </label>
            <textarea
              id="resolutionNote"
              className="form-input"
              rows={4}
              style={{ minHeight: "100px", padding: "0.75rem" }}
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder="Explain how this issue was resolved, or what changes were made..."
              required
              disabled={submitting}
            />
            <span style={{ fontSize: "0.75rem", color: "var(--text-muted)", display: "block", marginTop: "0.25rem" }}>
              This note will be visible to the user who submitted the ticket.
            </span>
          </div>

          <div className="modal-footer" style={{ display: "flex", justifyContent: "flex-end", gap: "0.75rem", marginTop: "1.5rem" }}>
            <button type="button" className="btn btn-secondary" onClick={onClose} disabled={submitting}>
              Cancel
            </button>
            <button type="submit" className="btn btn-success" disabled={submitting}>
              {submitting ? "Completing..." : "Complete & Save"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
